import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthContext";
//import axios from "axios";
import AddLog from "./AddLog"; // ✅ 로그 저장 함수 가져오기

import "../styles/UserRegisterModal.css"; // CSS 파일 import

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PartnerRegisterModal = ({ glist, onClose, onPartnerAdded }) => {
    const { user } = useAuth();    
    const [isIdValid, setIsIdValid] = useState(false); // 중복 여부 확인

    const [partnerCode, setPartnerCode] = useState("");
    //const [userId, setUserId] = useState("");    
    //const [userType, setUserType] = useState("U");
    const [partnerName, setPartnerName] = useState("");
    const [officeNumber, setOfficeNumber] = useState("");
    const [ownerName, setOwnerName] = useState("");    
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [governmentCode, setGovernmentCode] = useState("");

    // 페이지가 로드될 때 파트너 코드 생성
    useEffect(() => {
        const generatePartnerCode = () => {
            const currentDate = new Date();
            const year = currentDate.getFullYear().toString().slice(2);  // '25' (현재 연도)
            const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');  // '02' (현재 월)
            const day = currentDate.getDate().toString().padStart(2, '0');  // '18' (현재 일)
            const randomNum = Math.floor(Math.random() * 99) + 1;  // 01~99 랜덤 숫자
            const formattedRandomNum = randomNum.toString().padStart(2, '0');  // '04' 형식으로 맞추기

            return `P${year}${month}${day}${formattedRandomNum}`;  // 'P25021804' 형식
        };

        setPartnerCode(generatePartnerCode());
    }, []);  // 컴포넌트 마운트 시 한 번만 실행

    /*
    useEffect(() => {
        if (user.userType === "S") {
            if (userType === "S" || userType === "G") {
                setPartnerCode(""); // 조건1: 숨김 + 빈값
            }
        } else {
            setPartnerCode(user.partnerCode); // 조건2: 숨김 + user.partnerCode로 설정
        }
    }, [user.partnerCode, user.userType, userType]); // userType 또는 user.userType이 변경될 때 실행
    */

    // 아이디 중복 확인
    const handleCheckDuplicate = async () => {
        const trimmedPcode = partnerCode.trim();

        if (!(trimmedPcode.length === 9 && trimmedPcode.startsWith("P"))) {
            alert("파트너코드는 P로 시작하는 9자를 입력해야됩니다.");
            //setIdMessage("ID를 입력해 주세요.");
            setIsIdValid(false);
            return;
        }

        try {            
            const response = await fetch(`${API_BASE_URL}/api/Partner/check-duplicate?partnerCode=${trimmedPcode}`);
            const data = await response.json();

            if (data.exists) {
                alert("이미 사용 중인 ID입니다.");
                //setIdMessage("이미 사용 중인 ID입니다.");
                setIsIdValid(false);
            } else {
                alert("사용 가능한 ID입니다.");
                //setIdMessage("사용 가능한 ID입니다.");
                setIsIdValid(true);
            }
        } catch (error) {
            //console.error("ID 중복 확인 오류:", error);
            alert("중복 확인 중 오류가 발생했습니다.");
            //setIdMessage("중복 확인 중 오류가 발생했습니다.");
            setIsIdValid(false);
        }
    };

    // 카카오 주소 검색
    const handleSearchAddress = () => {
        new window.daum.Postcode({
            oncomplete: (data) => {
                // 주소를 DB에 저장
                setAddress1(data.address);
            },
            width: 500, // 창 너비
            height: 600, // 창 높이
        }).open({
            left: (window.screen.width / 2) - 250,  // 중앙 정렬 (화면 너비 기준)
            top: (window.screen.height / 2) - 300   // 중앙 정렬 (화면 높이 기준)
        });
    };

    // 저장 버튼 클릭
    const handleSave = async () => { // 'async' 추가
        
        if (!(partnerCode.length === 9 && partnerCode.startsWith("P"))) {
            alert("파트너코드는 P로 시작하는 9자를 입력해야됩니다.");
            setTimeout(() => {
                document.getElementsByName("partnercode")[0].focus();
            }, 0);
            return;
        }
        else if (!isIdValid) {
            alert("파트너코드 중복확인을 해주세요!");
            setTimeout(() => {
                document.getElementsByName("partnercodebt")[0].focus();
            }, 0);
            return;
        }
        else if (!partnerName.trim()) {
            alert("파트너명을 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("partnername")[0].focus();
            }, 0);
            return;
        }
        else if (!officeNumber.trim()) {
            alert("사업자 번호를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("officecode")[0].focus();
            }, 0);
            return;
        }
        else if (!ownerName.trim()) {
            alert("대표자명을 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("ownername")[0].focus();
            }, 0);
            return;
        }        
        else if (!address1.trim() ) {
            alert("주소검색으로 기본주소를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("addr1bt")[0].focus();
            }, 0);
            return;
        }
        else if (!address2.trim() ) {
            alert("나머지 주소를 입력 해주세요!");
            setTimeout(() => {
                document.getElementsByName("addr2")[0].focus();
            }, 0);
            return;
        }

        
        const newPartner = {
            PartnerCode: partnerCode,
            PartnerName: partnerName.trim(),            
            OfficeNumber: officeNumber.trim(),
            OwnerName: ownerName.trim(),            
            Address1: address1,
            Address2: address2.trim(),    
            GovernmentCode: governmentCode,
        };

        //console.log("신규 사용자 정보:", JSON.stringify(newUser, null, 2));
        //alert(newUser.userId);

        try {
            
            const response = await fetch(`${API_BASE_URL}/api/Partner/add-partner`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newPartner),
            });

            const data = await response.json();
            if (response.ok) {

                await AddLog(user.userId, "", newPartner.PartnerCode, "6-1");

                alert("파트너 등록이 완료되었습니다.");
                onPartnerAdded();  // 리스트 갱신을 요청하는 콜백 호출
                onClose();
            } else {
                alert("파트너 등록에 실패했습니다: " + data.message);
                //console.log("응답 상태 코드:", response.status);
                //console.log("서버 응답 데이터:", data);
            }
            
        } catch (error) {
            //console.error("오류:", error);
            alert("파트너 등록 중 오류가 발생했습니다.");
        }
       
        onClose();
    };

    return (
        <div className="modal-overlay2">
            <div className="modal-content2">
                {/* 모달 헤더 */}
                <div className="modal-header">
                    <h2>파트너 신규 등록</h2>
                    <button className="modal-close-btn" onClick={onClose}><i className="fa fa-times-circle"></i></button>
                </div>

                {/* 입력 필드 */}
                <div className="form-group2">
                    <label>파트너코드</label>
                    <div className="input-group2">                        
                        <input
                            name="partnercode"
                            type="text"
                            maxLength="9"
                            value={partnerCode}
                            onChange={(e) => setPartnerCode(e.target.value.trim().toUpperCase())}
                            disabled={isIdValid} // isIdValid가 true이면 편집 불가
                            style={{ backgroundColor: isIdValid ? "Whitesmoke" : "white", textTransform: 'uppercase' }} // 배경색 변경
                        />

                        <button
                            name="partnercodebt"
                            className={isIdValid ? "check-btn2" : "check-btn"}
                            onClick={handleCheckDuplicate}
                        >
                            <i className="fa fa-user"></i>
                        </button>
                    </div>
                    
                </div>

                <div className="form-group2">
                    <label>파트너명</label>
                    <div className="input-group2">
                        <input name="partnername" type="text" maxLength="18" value={partnerName} onChange={(e) => setPartnerName(e.target.value)} />
                    </div>
                </div>

                <div className="form-group2">
                    <label>사업자번호</label>
                    <div className="input-group2">
                        <input name="officecode" type="text" maxLength="18" value={officeNumber} onChange={(e) => setOfficeNumber(e.target.value)} />
                    </div>
                </div>

                <div className="form-group2">
                    <label>대표자명</label>
                    <div className="input-group2">
                        <input name="ownername" type="text" maxLength="18" value={ownerName} onChange={(e) => setOwnerName(e.target.value)} />
                    </div>
                </div>                

                <div className="form-group2">
                    <label>소재지1</label>
                    <div className="input-group2">
                        <input type="text" readOnly value={address1} />
                        <button name="addr1bt" className="search-btn" onClick={handleSearchAddress}><i className="fa fa-search"></i></button>
                    </div>
                </div>

                <div className="form-group2">
                    <label>소재지2</label>
                    <div className="input-group2">
                        <input name="addr2" type="text" maxLength="40" value={address2} onChange={(e) => setAddress2(e.target.value)} />
                    </div>
                </div>

                <div className="form-group2">
                    <label>관할광공서</label>
                    <div className="input-group2">
                        <select name="governmentCode" value={governmentCode} onChange={(e) => setGovernmentCode(e.target.value)}>
                            <option value="">관할 관공서를 선택하세요</option> {/* 기본값 */}
                            {glist.map((government) => (
                                <option key={government.snum} value={government.governmentCode}>
                                    {government.snum}, {government.governmentCode} : {government.governmentName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>


                {/* 저장 버튼 */}
                <button className="save-btn" onClick={handleSave}>저장</button>
            </div>
        </div>
    );
};

export default PartnerRegisterModal;
